<template>
    <form>
        <ModalEdition :isEdition="params.id != null" :modalId="'modalEditStock'" ref="modalStockRef" @save="saveStock">
            <div class="form">
                <div class="form-group">
                    <label for="stock_categorie">Categorie</label>
                    <select v-model="stock.categorie.id" class="form-select">
                        <option v-for="cat in categorie" :value="cat.id" :key="cat.id">
                            {{ cat.libelle }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="stock_zoneStockage">Zone de stockage</label>
                    <select v-model="stock.zoneStockage.id" class="form-select">
                        <option v-for="zone in zoneStockage" :value="zone.id" :key="zone.id">
                            {{ zone.libelle }}
                        </option>
                    </select>
                </div>
            </div>
        </ModalEdition>
    </form>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
    name: 'StockEdit',
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            stock: {
                categorie: {},
                zoneStockage: {},
            },
            zoneStockage: {},
            categorie: {},
            errors: [],
        }
    },
    mounted() {
        this.getZoneStockage();
        this.getCategorie();
    },
    methods: {
        getStock(id) {
            Axios.get('/stock/' + id).then(res => {
                this.stock = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des stocks :', err);
            });
        },
        getZoneStockage() {
            Axios.get('/zoneStockage').then(res => {
                this.zoneStockage = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des zone de stockage :', err);
            });
        },
        getCategorie() {
            Axios.get('/categorie').then(res => {
                this.categorie = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des catégories :', err);
            });
        },
        saveStock() {
            this.errors = [];
            if (!this.stock.categorie.id) {
                this.errors.push({ message: "La catégorie est obligatoire." });
            }
            if (!this.stock.zoneStockage.id) {
                this.errors.push({ message: "La zone de stockage est obligatoire." });
            }
            if (this.errors.length) {
                this.$refs.modalStockRef.errorMessage(this.errors)
                return;
            }

            Axios.post('/stock', this.stock)
                .then(() => {
                    this.$refs.modalStockRef.closeModal();
                    this.$emit('saved');
                }).catch(err => {
                    this.errors.push({ message: 'Erreur lors de la sauvegarde du stock:', err });
                });
        },
    },
    watch: {
        params: {
            handler(params) {
                if (params.id != null) {
                    this.getStock(params.id);
                } else {
                    this.stock.categorie = {};
                    this.stock.zoneStockage = {};
                }
            },
            deep: true,
        },
    },
}
</script>

<style>
.form {
    max-width: 300px;
    margin: 0 auto;
}

.formGroup {
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}
</style>
